import { api } from './api'

const enhancedApi = api.enhanceEndpoints({
  addTagTypes: [
    'releaseNote',
  ],
})

const extendedApi = enhancedApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchReleaseNotes: builder.query({
      query: () => '/release_notes',
      providesTags: (result) => [{ type: 'releaseNote', id: 'LIST' }],
    }),

    createReleaseNote: builder.mutation({
      query: ({ params }) => ({
        url: '/admin/release_notes',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['releaseNote'],
    }),

    updateReleaseNote: builder.mutation({
      query: ({ id, params }) => {
        return ({
          url: `/admin/release_notes/${id}`,
          method: 'PATCH',
          body: params,
        })
      },
      invalidatesTags: ['releaseNote'],
    }),

    createReleaseNoteSubscription: builder.mutation({
      query: () => {
        return ({
          url: 'release_notes/subscribe',
          method: 'POST',
        })
      },
      invalidatesTags: ['releaseNote'],
    }),

    removeReleaseNoteSubscription: builder.mutation({
      query: () => {
        return ({
          url: 'release_notes/unsubscribe',
          method: 'DELETE',
        })
      },
      invalidatesTags: ['releaseNote'],
    }),

    removeReleaseNote: builder.mutation({
      query: ({ id }) => ({
        url: `/admin/release_notes/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['releaseNote'],
    }),
  }),
  overrideExisting: false,
})

export const {
  useFetchReleaseNotesQuery,
  useCreateReleaseNoteMutation,
  useUpdateReleaseNoteMutation,
  useCreateReleaseNoteSubscriptionMutation,
  useRemoveReleaseNoteSubscriptionMutation,
  useRemoveReleaseNoteMutation,
} = extendedApi
